import { Component } from '@angular/core';

@Component({
  selector: 'mprd-priceplan-details-skeleton',
  templateUrl: './priceplan-details-skeleton.component.html',
})
export class PriceplanDetailsSkeletonComponent {
  constructor() {}
}
